/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerformanceMetricRanking } from './PerformanceMetricRanking';
import {
  PerformanceMetricRankingFromJSON,
  PerformanceMetricRankingFromJSONTyped,
  PerformanceMetricRankingToJSON,
} from './PerformanceMetricRanking';

/**
 *
 * @export
 * @interface PaginatedPerformanceMetricRankingList
 */
export interface PaginatedPerformanceMetricRankingList {
  /**
   *
   * @type {number}
   * @memberof PaginatedPerformanceMetricRankingList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedPerformanceMetricRankingList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedPerformanceMetricRankingList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<PerformanceMetricRanking>}
   * @memberof PaginatedPerformanceMetricRankingList
   */
  results: Array<PerformanceMetricRanking>;
}

/**
 * Check if a given object implements the PaginatedPerformanceMetricRankingList interface.
 */
export function instanceOfPaginatedPerformanceMetricRankingList(
  value: object,
): value is PaginatedPerformanceMetricRankingList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedPerformanceMetricRankingListFromJSON(json: any): PaginatedPerformanceMetricRankingList {
  return PaginatedPerformanceMetricRankingListFromJSONTyped(json, false);
}

export function PaginatedPerformanceMetricRankingListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedPerformanceMetricRankingList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(PerformanceMetricRankingFromJSON),
  };
}

export function PaginatedPerformanceMetricRankingListToJSON(value?: PaginatedPerformanceMetricRankingList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(PerformanceMetricRankingToJSON),
  };
}
